module.exports = __webpack_public_path__ + "img/secador-pelo.7c050de3.svg";